// Expo SDK pinned for generated projects and Snack previews (Expo Go compatibility).
export const EXPO_SDK_VERSION = "54.0.0";

// Build a URL that opens the current code in https://snack.expo.dev (browser tab).
export function buildSnackUrl(code, { name = "Consensus A.I. App" } = {}) {
  const params = new URLSearchParams({
    name,
    description: "Generated by The Consensus A.I.",
    dependencies: "",
    platform: "web",
    supportedPlatforms: "ios,android,web",
    sdkVersion: EXPO_SDK_VERSION,
    code,
  });
  return `https://snack.expo.dev/?${params.toString()}`;
}

/**
 * Save the Snack to Expo servers and return URLs that work in Expo Go.
 * Uses saveAsync (persisted snack id), not a live pubsub session — the old
 * setOnline(true)/setOnline(false) flow caused Expo Go to spin on "Connecting…".
 */
export async function createSavedSnack(
  code,
  { name = "Consensus A.I. App", sdkVersion = EXPO_SDK_VERSION } = {}
) {
  const { Snack } = await import("snack-sdk");
  const snack = new Snack({
    name,
    sdkVersion,
    files: {
      "App.js": {
        type: "CODE",
        contents: code,
      },
    },
  });

  const { id, url } = await snack.saveAsync({ ignoreUser: true });
  if (!id || !url) {
    throw new Error("Could not create an Expo Go link. Try again in a moment.");
  }

  return {
    id,
    expoGoUrl: url,
    snackWebUrl: `https://snack.expo.dev/${id}`,
  };
}

/** @deprecated Use createSavedSnack instead. */
export async function createExpoGoUrl(code, options) {
  const saved = await createSavedSnack(code, options);
  return saved.expoGoUrl;
}
